"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "HighbondLogo___StyledSvg",
  componentId: "rd9a5q-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function HighbondLogo(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M332.277 299.668L454 53H332.291L226.815 266.741l.003-.01c-3.953 7.84-11.22 10.122-16.343 10.122-4.754 0-11.53-2.346-15.4-8.602l-45.366-91.919H28l60.863 123.336h.005L28 423h121.709l44.621-90.406-.003.011c3.954-7.842 11.218-10.126 16.341-10.126 4.756 0 11.532 2.346 15.403 8.605L271.437 423h121.709L332.28 299.668h-.003"
  }));
}

var _default = HighbondLogo;
exports["default"] = _default;